<template>
	<div class="row-fluid">
		<div class="span12 text-left" style="margin-bottom: 20px; margin-top: 20px;">
			<div class="bg_voice">
				<img style="width: 100%; border-radius:10px;" src="https://img.hsnms.com/20220415/1649999096.jpeg" />
			</div>
		</div>

		<div class="app-container">
			<div class="the-container">
				<el-tabs stretch="" v-model="usable" :tab-position="tabPosition" @tab-click="handleClick">
					<el-tab-pane v-for="(tab,index) in tabs" :key="index" :name="tab.name" :label="tab.label">
						<div v-show="usable==='1'">
							<el-form ref="form" :model="form">
								<div style="margin-bottom: 2rem;">
									<div class="bt_hs1 tiaoti_a">姓名</div>
									<el-input class="tiaoti_a_int" placeholder="请填写申报人姓名" v-model="form.name">
									</el-input>
								</div>
								<div style="margin-bottom: 2rem;">
									<div class="bt_hs1 tiaoti_a">身份证</div>
									<el-input placeholder="请填写申报人身份证" v-model="form.name"></el-input>
								</div>
								<div style="margin-bottom: 2rem;">
									<div class="bt_hs1 tiaoti_a">联系电话</div>
									<el-input placeholder="请填写申报人联系电话" v-model="form.name"></el-input>
								</div>
								<div style="margin-bottom: 2rem;">
									<div class="bt_hs1 tiaoti_a">月均收入</div>
									<el-input placeholder="请填写月均收入" v-model="form.name"></el-input>
								</div>
								<div style="margin-bottom: 2rem;">
									<div class="bt_hs1 tiaoti_a">基本情况</div>
									<el-input type="textarea" placeholder="困难及家庭情况" v-model="form.desc" :rows="5">
									</el-input>
								</div>
								<el-form-item style="margin-top: 30px;">
									<el-button class="bin_tijiao" type="primary">提交申请</el-button>
								</el-form-item>
							</el-form>



						</div>
						<div v-show="usable==='2'">
							<div class="span12" style="margin-top: 5px;margin-bottom: 5px;"
								v-for="(item, index) in data_list_a.data" @click="route1(item.connect)">
								<!--t_10-->
								<div class="row">
									<div class="col-2" style="padding-right:1px;">
										<div style="position:relative;width:100%;">
											<img style="width: 100%; border-radius:3%;"
												src="https://img.hsnms.com/20220414/1649944737.webp" />
										</div>
									</div>
									<div class="col-10">
										<h4>{{item.title}}</h4>
										<h5 style="margin-top: 20px;">
											<samp
												style="background: #b84031; color: #fff; padding: 5px; border-radius:10px;">点击下载</samp>
										</h5>
									</div>

								</div>
								<hr />
							</div>
							
							<el-button class="bin_tijiao_data" type="primary" v-if="data_list_a.v" @click="list_a">
								更多内容
							</el-button>

						</div>
						<div v-show="usable==='3'">
							<h1>部门管理</h1>
						</div>
						<div v-show="usable==='4'">
							<h1>部门管理</h1>
						</div>
					</el-tab-pane>
				</el-tabs>
			</div>
		</div>
		<div style="height: 20px;"></div>


	</div>
</template>

<script>
	export default {
		data() {
			return {
				data_list_a: {
					data: [],
					page: 1,
					v: false,
				},
				form: {
					name: '',
					region: '',
					date1: '',
					date2: '',
					delivery: false,
					type: [],
					resource: '',
					desc: ''
				},
				tabPosition: 'top',
				usable: '1',
				tabs: [{
						name: '1',
						label: '帮扶申请'
					},
					{
						name: '2',
						label: '资料下载'
					}
				]
			}
		},
		mounted() {
			this.list_a()
		},
		methods: {
			route1: function(myurl) {
				window.open(myurl,"_blank");
			},
			list_a() {
				var datas = this.data_list_a;
				this.$api.getAPI("data/info/?type_id=2022040014&page=" + datas.page, {
					key_id: this.$route.query.id,
				}).then(res => {
					var lists = res.data.data.data[0].models;
					if (lists.length == 10) {
						datas.v = true;
						this.data_list_a.page = datas.page + 1;
					} else {
						this.data_list_a.v = false;
					}
					for (let i = 0; i < lists.length; i++) {
						this.data_list_a.data.push(lists[i])
					}
				})
			},
			handleClick(tab) {
				console.log(tab)
			}
		}
	}
</script>

<style>
	.bin_tijiao_data {
		height: 50px;
		width: 100%;
		font-size: 16px;
		opacity: 0.6;
	}
	.t_b .col-3 .b_t_5 {
		margin-top: 5px;
	}

	.t_b .col-3 {
		margin-top: 10px;
	}


	.bin_tijiao {
		height: 50px;
		width: 100%;
		font-size: 16px
	}

	.tiaoti_a {
		margin-bottom: .5rem;
		font-size: 16px
	}

	.el-tabs__item {
		font-size: 18px !important;
	}

	.tiaoti_a_int {
		font-size: 16px;
	}

	.el-input__inner {
		padding-left: 10px !important;
		height: 45px !important;
		line-height: 45px !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/views/jjgh/knbf.vue